import React from 'react';
import DataTable from 'components/DataTable'
import {
    Edit as EditIcon,
    Delete as DeleteIcon,
} from '@material-ui/icons'

import MuiPaper from '@material-ui/core/Paper';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next'

import Image from 'components/Img'
import Dessins from 'data/Dessins';

import { useCurrentPermissionProfile } from 'redux/hooks';
import { deleteDessin } from 'Api'
import { sortAlphaNum} from 'Util/Sorting'

const Paper = styled(MuiPaper)`
    padding: 10px;
`

export default ({ data = Dessins, actions, onChange, onClickEdit, headerActions }) => {

    const { t } = useTranslation();
    const permissionProfile = useCurrentPermissionProfile();
    const canDelete = permissionProfile === 'comite' || permissionProfile === 'admin' || permissionProfile === null;
    const canEdit = permissionProfile === 'comite' || permissionProfile === 'admin' || permissionProfile === 'avila' || permissionProfile === 'regisseur' || permissionProfile === null;


    data.sort(function (a, b) {

        if ( a.archive && b.archive ) {
            return sortAlphaNum(a.archive.toLowerCase(), b.archive.toLowerCase())
        }
        return -1
    });
    
    async function deleteDessinAsync(dessin) {

        await deleteDessin({ dessin });
        onChange(data.filter(e => e.objectid !== dessin.objectid))
    }

    return (
        <Paper elevation={3}>
            {headerActions && (
                <div>
                    {headerActions}
                </div>
            )}
            <DataTable
                data={data}
                config={{
                    onClickRow: dessin => {
                        window.open("/dessin/" + dessin.objectid)

                    },
                    cells: [
                        { title: t('nb_archive'), key: 'archive', bold:true, width:150 },
                        { title: t('photo'), key: 'filename', width:150 },
                        { title: t('annee'), key: 'annee', width:150 },
                        { title: t('oeuvres'), key: 'oeuvres' },
                    ],
                    actions: actions || [
                        ...(canEdit ? [
                        {
                            icon: <EditIcon />, title: "Edit",
                            onClick: (id, dessin) => {
                                window.open("/dessin/" + dessin.objectid)
                            }
                        }, ] : []),
                        ...(canDelete ? [
                        {   
                            icon: <DeleteIcon />, title: "Delete",
                            onClick: (id, dessin) => {  
                                if ( window.confirm('Etes vous certain de vouloir l\'effacer?')) {
                                    deleteDessinAsync(dessin)
                                }
                            }
                        } ] : [])
                    ]
                }}
                getCell={(item, attr_name) => {

                    if (attr_name === "filename") {
                        return (
                            <Image
                                imageWidth={60}
                                style={{justifyContent: 'flex-start'}}
                                alt="" filename={item.filename}
                            />
                        )
                    }
                    if (attr_name === "oeuvres") {
                        var stringArchives = ""
                        const oeuvre_archives = item["oeuvre_archive"]

                        if ( oeuvre_archives ) {

                            oeuvre_archives.forEach(archive => {
                                stringArchives = "#" + stringArchives + archive +", "
                            })
                        }
                        return stringArchives
                    }
                    return Object.prototype.hasOwnProperty.call(item, attr_name) ? item[attr_name] : '';
                }}
            />
        </Paper>


    )
}